import React, { useEffect, useState } from "react";
import axios from "axios";
import { Authorization } from "../../Context/Authorization";
import Preloader from "../../shared/PreLoaders";

const thStyle = { padding: "10px 12px", fontSize: 12, fontWeight: 700, color: "#2D3748", background: "#F7FAFC", border: "1px solid #E2E8F0", textAlign: "left" };
const tdStyle = { padding: "9px 12px", fontSize: 12, color: "#4A5568", border: "1px solid #E2E8F0" };

const statusColors = {
  SUCCESS: { bg: "#C6F6D5", color: "#22543D" },
  FAILED: { bg: "#FED7D7", color: "#742A2A" },
  PENDING: { bg: "#FEFCBF", color: "#744210" },
};

const VerifyManualPayments = () => {
  const Api = process.env.REACT_APP_API;
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updatingId, setUpdatingId] = useState(null);

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${Api}/api/check/manual-payments`, Authorization());
      setPayments(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load payments");
    } finally {
      setLoading(false);
    }
  };

  const updatePayment = async (id, status) => {
    try {
      setUpdatingId(id);
      await axios.put(`${Api}/api/check/verify-manual-payment`, { paymentId: id, status }, Authorization());
      fetchPayments();
    } catch (err) {
      console.error(err);
      alert("Failed to update payment");
    } finally {
      setUpdatingId(null);
    }
  };

  if (loading) return <Preloader loading={loading} />;

  return (
    <div>
      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Manual Payment Verification</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>JFMC Maintenance Fee</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Verify Manual Payments</span>
        </div>
      </div>

      {/* ── Table Card ── */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
            <i className="mdi mdi-cash-check" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#fff", flex: 1 }}>Payment List</span>
          <span style={{ padding: "3px 10px", background: "rgba(255,255,255,0.2)", borderRadius: 20, fontSize: 11, color: "#fff", fontWeight: 600 }}>
            {payments.length} Records
          </span>
        </div>

        <div style={{ padding: 16, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Range</th>
                <th style={thStyle}>VFCs</th>
                <th style={thStyle}>Transaction ID</th>
                <th style={thStyle}>Invoice No</th>
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Amount</th>
                <th style={thStyle}>Proof</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {payments.length === 0 ? (
                <tr>
                  <td colSpan={8} style={{ ...tdStyle, textAlign: "center", color: "#A0AEC0", padding: "40px" }}>No payment records found.</td>
                </tr>
              ) : (
                payments.map((payment, index) => {
                  const sc = statusColors[payment.status] || statusColors.PENDING;
                  const isUpdating = updatingId === payment._id;
                  return (
                    <tr key={payment._id} style={{ background: index % 2 === 0 ? "#fff" : "#F7FAFC" }}>
                      <td style={tdStyle}>{index + 1}</td>
                      <td style={{ ...tdStyle, fontWeight: 600, color: "#2D3748" }}>{payment.rangeId?.rangeName || "-"}</td>
                      <td style={tdStyle}>{payment.vfcIds?.length || 0}</td>
                      <td style={tdStyle}>{payment.transactionId || "-"}</td>
                      <td style={tdStyle}>{payment.invoiceNo || "-"}</td>
                      <td style={tdStyle}>{payment.paidOn ? new Date(payment.paidOn).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-"}</td>
                      <td style={{ ...tdStyle, fontWeight: 600 }}>₹ {payment.totalAmount}</td>

                      <td style={tdStyle}>
                        {payment.proofUrl ? (
                          <a href={payment.proofUrl} target="_blank" rel="noreferrer"
                            style={{ color: "#2E7D32", fontWeight: 600, fontSize: 12 }}>View</a>
                        ) : "-"}
                      </td>
                      <td style={tdStyle}>
                        <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: sc.bg, color: sc.color }}>
                          {payment.status}
                        </span>
                      </td>
                      <td style={tdStyle}>
                        {payment.status === "PENDING" && (
                          <div style={{ display: "flex", gap: 6 }}>
                            <button disabled={isUpdating} onClick={() => updatePayment(payment._id, "SUCCESS")}
                              style={{ padding: "5px 12px", background: isUpdating ? "#A0AEC0" : "linear-gradient(135deg,#1B5E20,#2E7D32)", color: "#fff", border: "none", borderRadius: 6, fontSize: 11, fontWeight: 700, cursor: isUpdating ? "not-allowed" : "pointer" }}>
                              Approve
                            </button>
                            <button disabled={isUpdating} onClick={() => updatePayment(payment._id, "FAILED")}
                              style={{ padding: "5px 12px", background: isUpdating ? "#A0AEC0" : "#E53E3E", color: "#fff", border: "none", borderRadius: 6, fontSize: 11, fontWeight: 700, cursor: isUpdating ? "not-allowed" : "pointer" }}>
                              Reject
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default VerifyManualPayments;
